export default __webpack_public_path__ + "static/media/mpn-logotype-l.2399f74b.svg";